export default class TableRequest {
  /**
   * Create a table request.
   *
   * @param {number} pageNumber
   * @param {number} pageSize
   * @param {Object} sort
   * @param {Array} [filters]
   */
  constructor (pageNumber, pageSize, sort, filters) {
    this.pageNumber = pageNumber
    this.pageSize = pageSize
    this.sort = sort
    this.filters = Array.isArray(filters) ? filters : []
  }

  /**
   * Get params for request.
   *
   * @param {Function} customSort
   *
   * @return {object}
   */
  getParams (customSort) {
    const params = {
      pagenumber: this.pageNumber,
      pagesize: this.pageSize
    }

    if (customSort) {
      customSort(params, this.sort)
    } else {
      if (this.sort !== null && this.sort.by) {
        const direction = (this.sort.desc ? '-' : '')

        if (Array.isArray(this.sort.by)) {
          // Multiple sort
          const sort = []

          for (let property of this.sort.by) {
            sort.push(direction + property)
          }

          params.sort = sort.join(',')
        } else {
          // Single sort
          params.sort = direction + this.sort.by
        }
      }
    }

    this.filters.filter(filter => filter.hasValue()).forEach(filter => {
      params[filter.property.toLowerCase()] = filter.toString().toLowerCase()
    })

    return params
  }
}
